import UserPersonaTypes from '../../constants/UserPersonaTypes';

const getUserPersonaType = (
  faNumber: string | null,
  entityID: string | null,
  contactID: string | null,
  contactType: string | null,
  createTimeStamp: string | null,
  utmSource: string | null,
  locale: string | null
) => {
  if (locale === 'en_US') {
    if (faNumber) {
      if (contactID) {
        if (utmSource === 'ff') {
          return UserPersonaTypes.FINANCIAL_FOUNDATION;
        }
        if (contactType && createTimeStamp) {
          if (utmSource === 'newsletter' && contactType === 'C') {
            return UserPersonaTypes.NEWS_LETTER;
          }
          return UserPersonaTypes.WORD_POWER;
        }
      }
      return UserPersonaTypes.PERSONAL_LINK;
    }
    if (entityID) {
      return UserPersonaTypes.PERSONAL_LINK_FA_PROFILE;
    }
  }
  if (locale === 'en_CA' || locale === 'fr_CA') {
    if (faNumber) {
      if (contactID) {
        if (locale === 'en_CA' && utmSource === 'ff') {
          return UserPersonaTypes.FINANCIAL_FOUNDATION_CA;
        }
        if (contactType && createTimeStamp) {
          if (utmSource === 'newsletter' && contactType === 'C') {
            return UserPersonaTypes.NEWS_LETTER_CA;
          }
          return UserPersonaTypes.WORD_POWER_CA;
        }
      }
      return UserPersonaTypes.PERSONAL_LINK_CA;
    }
    if (entityID) {
      return UserPersonaTypes.PERSONAL_LINK_FA_PROFILE_CA;
    }
    return UserPersonaTypes.DIRECT_URL_CA;
  }
  return UserPersonaTypes.DIRECT_URL;
};

export default getUserPersonaType;